import { render } from "./Yandex.vue?vue&type=template&id=061ca970"
import script from "./Yandex.vue?vue&type=script&lang=js"
export * from "./Yandex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__